export const options = [
  {
    id: 'less-than-1',
    title: '< 1 year',
    ariaLabel: 'Less than 1 year',
    data: '< 1 year',
  },
  {
    id: '1-2',
    title: '1 - 2 years',
    ariaLabel: 'Between 1 and 2 years',
    data: '1 - 2 years',
  },
  {
    id: 'more-than-2',
    title: '2+ years',
    ariaLabel: 'More than 2 years',
    data: '2+ years',
  },
  {
    id: 'never',
    title: "I've never visited",
    data: 'Never',
  },
];
